import React from 'react';
import {
  List,
  Show,
  Create,
  Edit,
  Datagrid,
  TextField,
  TextInput,
  SimpleForm,
  SimpleShowLayout,
  ReferenceField,
  RichTextField,
  ReferenceInput,
  SelectInput,
  RefreshButton,
  CardActions,
  ShowButton,
  EditButton,
  ImageInput,
  ImageField,
  DateField,
  required,
} from 'react-admin';
import { parse } from 'qs';
import RichTextInput from 'ra-input-rich-text';
import Icon from '@material-ui/icons/ViewModule';
import Title from './Title';
import Picture from './Picture';
import PictureDetail from './PictureDetail';
import ImageGridField from 'components/ImageGridField';
import UploadToolbar from 'components/UploadToolbar';
import PictureNote from 'components/PictureNote';

export const CarModelIcon = Icon;

// const CarModelFilter = props => (
//   <Filter {...props}>
//     <TextInput label="Search" source="q" alwaysOn />
//     <ReferenceInput label="Car Model" source="name" allowEmpty>
//       <SelectInput optionText="name" />
//     </ReferenceInput>
//   </Filter>
// );

const ListActions = () => {
  return (
    <CardActions>
      <RefreshButton />
    </CardActions>
  );
};

export const CarModelList = props => (
  <List {...props} title="Car Models" actions={<ListActions />}>
    <Datagrid>
      <TextField source="name" label="Model Name" />
      <ImageGridField source="img_url" title="title" label="Image" />
      <ImageGridField source="img_detail_url" title="title" label="Image Detail" />
      <ReferenceField
        label="Car Brand"
        source="car_brand_id"
        sortBy="car_brands.name"
        reference="brands"
        allowEmpty={true}
      >
        <TextField source="name" />
      </ReferenceField>
      <DateField source="updated_at" showTime={true} />
      <ShowButton />
      <EditButton />
    </Datagrid>
  </List>
);

export const CarModelShow = props => (
  <Show {...props}>
    <SimpleShowLayout>
      <ReferenceField source="car_brand_id" reference="brands" label="Car Brand">
        <TextField source="name" />
      </ReferenceField>
      <ImageField source="img_url" title="title" />
      <ImageField source="img_detail_url" title="title" />
      <TextField source="name" label="Model Name" />
      <RichTextField source="description" />
      <DateField label="Created date" showTime={true} source="created_at" />
      <DateField label="Updated date" showTime={true} source="updated_at" />
    </SimpleShowLayout>
  </Show>
);

export const CarModelCreate = props => {
  const query = parse(props.location.search, { ignoreQueryPrefix: true });
  let redirect = 'edit',
    brand_id = '';
  if (query.brand_id) {
    brand_id = parseInt(query.brand_id, 10);
    redirect = `/brands/${brand_id}/1`;
  }

  return (
    <Create title={'New Model'} {...props}>
      <SimpleForm
        defaultValue={{ car_brand_id: brand_id }}
        redirect={redirect}
        toolbar={<UploadToolbar source={['img_url', 'img_detail_url']} />}
      >
        <ReferenceInput source="car_brand_id" reference="brands" validate={required()} perPage={-1}>
          <SelectInput optionText="name" />
        </ReferenceInput>
        <TextInput source="name" label={'Model name'} validate={required()} />
        <ImageInput source="qimg_url" label="Image" accept="image/jpeg,image/png" validate={required()}>
          <ImageField source="src" title="title" />
        </ImageInput>
        <PictureNote width="400" height="400" />
        <ImageInput source="qimg_detail_url" label="Image Detail" accept="image/jpeg,image/png" validate={required()}>
          <ImageField source="src" title="title" />
        </ImageInput>
        <PictureNote width="200" height="400" />
        <RichTextInput source="description" />
      </SimpleForm>
    </Create>
  );
};

export const CarModelEdit = props => {
  const query = parse(props.location.search, { ignoreQueryPrefix: true });
  let redirect = 'list',
    brand_id = '';
  if (query.brand_id) {
    brand_id = parseInt(query.brand_id, 10);
    redirect = `/brands/${brand_id}/1`;
  }
  return (
    <Edit title={<Title />} {...props}>
      <SimpleForm redirect={redirect} toolbar={<UploadToolbar source={['img_url', 'img_detail_url']} />}>
        <ReferenceInput source="car_brand_id" reference="brands" validate={required()} perPage={-1}>
          <SelectInput optionText="name" />
        </ReferenceInput>
        <TextInput source="name" validate={required()} />
        <Picture />
        <ImageInput source="qimg_url" label="New Picture" accept="image/jpeg,image/png">
          <ImageField source="src" title="title" />
        </ImageInput>
        <PictureNote width="400" height="400" />
        <PictureDetail />
        <ImageInput source="qimg_detail_url" label="New Detail Picture" accept="image/jpeg,image/png">
          <ImageField source="src" title="title" />
        </ImageInput>
        <PictureNote width="200" height="400" />
        <RichTextInput source="description" />
      </SimpleForm>
    </Edit>
  );
};



// WEBPACK FOOTER //
// ./src/containers/CarModel/index.js